<template>
	<div>
		<!-- <div class="steps">
			<div class="item" :class="{active: step == 1}" @click="showStep(1)"><div class="ico"><i class="el-icon-check"></i><span>1</span></div>排期记录</div>
			<div class="item" :class="{active: step == 2}" @click="showStep(2)"><div class="ico"><i class="el-icon-check"></i><span>2</span></div>随访问卷</div>
			<div class="item" :class="{active: step == 3}" @click="showStep(3)"><div class="ico"><i class="el-icon-check"></i><span>3</span></div>六大处方</div>
		</div> -->
		<tab1 v-if="step == 1"  :dataId="dataId"></tab1>
		<!-- <tab2 v-if="step == 2"></tab2>
		<tab3 v-if="step == 3"></tab3> -->

				
	</div>
</template>

<script>
import mixin from '@/views/mixin';
import Tab1 from './user-followup-2-1.vue';
// import Tab2 from './user-followup-2-2.vue';
// import Tab3 from './user-followup-2-3.vue';

export default {
	// components: {Tab1, Tab2, Tab3},
	components: {Tab1},
	props: {
		dataId: {
			required: true
		}
	},
  mixins: [mixin],
	data(){
		return {
			noSidebar: true,
			step: 1,
		}
	},
	created() {
		// this.step = 2;
	},
	methods: {
		showStep(v) { this.step = v;}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.w-tabs {
	>.tabs {padding: 20px 30px;}
}
.steps {
	position: relative;
	margin: 30px 160px;
	text-align: center;
	justify-content: space-between;
	display: flex;
	&::after {
		position: absolute;
		top: 12px;
		left: 20px;
		right: 20px;
		height: 2px;
		background: #c0c4cc;
		content: '';
	}
	.item {
		position: relative;
		padding-top: 40px;
		color: #999;
		cursor: pointer;
		z-index: 2;
		&.active {
			color: #409EFF;
			.ico {
				border-color: #409EFF;
				i { padding-top: 6px; font-weight: 700; display: block;}
				span {display: none;}
			}
		}
		.ico {
			position: absolute;
			top: 0;
			left: 8px;
			width: 24px;
			height: 24px;
			line-height: 24px;
			border: 2px solid #c0c4cc;
			border-radius: 50%;
			background: #fff;
			i {display: none;}
		}
	}
}
.table-wrap {
	margin-left: 0;
	margin-right: 0;
}


</style>
